<script lang="ts">
	// The row of triggers, with a baseline border the active trigger's underline
	// sits on. NO arbitrary `[..]` values.
	import { Tabs as TabsPrimitive } from "bits-ui";
	import { cn } from "../../../utils.js";

	let {
		ref = $bindable(null),
		class: className,
		...restProps
	}: TabsPrimitive.ListProps = $props();
</script>

<TabsPrimitive.List
	bind:ref
	data-slot="tabs-list"
	class={cn("flex items-center gap-1 border-b border-border", className)}
	{...restProps}
/>
